/**
 * Firefox up to version 69 did not throw an error when setting a different channelCount or channelCountMode.
 */
export var createTestChannelMergerNodeChannelCountSupport = function createTestChannelMergerNodeChannelCountSupport(createNativeAudioNode, nativeOfflineAudioContextConstructor) {
  return function () {
    if (nativeOfflineAudioContextConstructor === null) {
      return false;
    }

    var offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
    var nativeChannelMergerNode = createNativeAudioNode(offlineAudioContext, function (ntvCntxt) {
      return ntvCntxt.createChannelMerger();
    });

    try {
      nativeChannelMergerNode.channelCount = 2;
    } catch (_unused) {
      return true;
    }

    return false;
  };
};